export const USER_CATEGORY = {
  VENDOR: 1,
  ADMIN_STAFF: 2,
  INTERNAL_STAFF: 0,
};

export const PROCUREMENT_TYPE = {
  Asset: 0,
  Consummable: 1,
  Consummable_Type: {
    Goods: "goods",
    Services: "service",
  },
};

export const ONBOARDING_STAGES = {
  PERSONAL_DETAILS: 1,
  CONTACT_DETAILS: 2,
  INSURANCE_DETAILS: 3,
  BANK_DETAILS: 4,
  BUSINESS_DOCUMENTS: 5,
  REVIEW: 6,
  ALL_DONE: 7,
  SUCCESS: 8,
};
